<template>
  <v-container>
    <h1>Logged</h1>
    <v-row style="max-width: 1024px; margin: auto">
      <v-col :cols="listItemCols">
        <v-card max-width="300">
          <h2 class="text-center">Filter</h2>
          <v-checkbox v-model="filters" label="Movies" :value="$mediums.FILM" class="ma-0" dense />
          <v-checkbox v-model="filters" label="Books" :value="$mediums.BOOK" class="ma-0" dense />
          <v-checkbox v-model="filters" label="Podcasts" :value="$mediums.PODCAST" class="ma-0" dense />
          <v-checkbox v-model="filters" label="Albums" :value="$mediums.ALBUM" class="ma-0" dense />
          <v-checkbox v-model="filters" label="TV Shows" :value="$mediums.TV_SHOW" class="ma-0" dense />
        </v-card>
      </v-col>
      <v-col v-for="item in filteredList" :key="item.medium + item.internal_id" :cols="listItemCols">
        <router-link :to="{ name: 'work', params: { medium: item.medium, workId: item.work_id } }">
          <v-card class="text-center" height="100%">
            <v-img :src="item.poster_source" width="100%" />
            {{ item.title }}
          </v-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "LogPage",
  data: () => ({
    seenList: [],
    filters: [],
  }),
  computed: {
    listItemCols() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 4;
        default:
          return 2;
      }
    },
    filteredList() {
      if (this.filters.length > 0) {
        return this.seenList.filter((item) => this.filters.includes(item.medium));
      } else {
        return this.seenList;
      }
    },
  },
  mounted() {
    console.log(this.filters);
    this.getViewed();
  },
  methods: {
    getViewed: function () {
      this.$axios
        .get("/works-viewed", {
          params: {
            user: this.$route.params.username,
          },
        })
        .then((response) => {
          console.log(response);
          this.seenList = response.data.film.concat(
            response.data.podcast,
            response.data.book,
            response.data.album,
            response.data.tvShow,
          );
        });
    },
  },
};
</script>

<style scoped></style>
